import { addDays, format, isBefore, isToday, parseISO } from "date-fns";
import _ from "underscore";
import React from "react";
import { compose } from "redux";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { browserPropType, userDataPropType, gridViewPropType } from "components/propTypes";
import ActionLogger from "action-logger";
import AvailabilityFilterHelpers from "helpers/availability-filter-helpers";
import AvailabilityPreferencesModalHelpers from "helpers/availability-preferences-modal-helpers";
import Constants from "rtr-constants";
import deliveryCutoffActions from "actions/delivery-cutoff-actions";
import { getDefaultShippingZip, getSizeLabel, formattedDeliveryDate } from "helpers/dfc-ux-helper";
import { isGridType } from "helpers/filter-helpers";
import GridSuperBar from "components/source/new_taxonomy/grid-superbar";
import GridTopFiltersAddressModal from "components/source/new_taxonomy/grid-top-filters-address-modal";
import GridAvailabilityModal from "components/source/new_taxonomy/grid-availability-modal";
import GridTopFiltersDateModal from "components/source/new_taxonomy/grid-top-filters-date-modal";
import GridTopFiltersSizeModal from "components/source/new_taxonomy/grid-top-filters-size-modal";
import GridTopFiltersZipModal from "components/source/new_taxonomy/grid-top-filters-zip-modal";
import holdPreferencesActions from "actions/hold-preferences-actions";
import { inMaternityExperience } from "helpers/maternity-helper";
import MembershipHelpers, { isProspectWithSubscriptionIntent } from "helpers/membership-helpers";
import MembershipRentalBeginActions from "actions/membership-rental-begin-actions";
import productsActions from "actions/products-actions";
import productDrawerActions from "actions/product-drawer-actions";
import RentalOptionIntent, { ActionsTaken, RentalOptions } from "helpers/rental-option-intent-helper";
import { loadAddressBook } from "actions/shipping-step-actions";
import SortDropdown from "components/source/new_taxonomy/sort-dropdown";
import { isAdmin, withUserData, isProMember, isIdentified } from "components/source/hoc/with-user-data";
import PinIcon from "images/sprites/reb/svg/superbar-pin.svg";
import CalIcon from "images/sprites/reb/svg/superbar-cal.svg";
import FilterIcon from "images/sprites/reb/svg/filter-icon.svg";
import RtrParcelIcon from "images/sprites/reb/svg/rtr-parcel.svg";
import { withCookies } from "react-cookie";
import { isFilteredByShippingAddress, isFilteredByShippingAddressNext } from "helpers/grid-top-filters-helpers";
import {
  closeModal,
  openDateFilterModal,
  openGridAvailabilityModal,
  openMobileFilterModal,
  openShippingFilterModal,
  openSizeFilterModal,
  openZipFilterModal,
} from "actions/grid-modal-actions";
import {
  flagsAndExperimentsPropType,
  withOnLoadFlagsAndExperiments,
  flagsAndExperimentNames,
} from "../hoc/with-flags-and-experiments";
import { isStorefrontNext } from "helpers/environment-helpers";
import HeapHelpers from "helpers/heap-helpers";
import {
  mapGridQueryToLegacyFilters,
  generateRubyStyleUrl,
  parseQueryString,
  setFilter,
  removeFilterWhen,
} from "helpers/disco-filter-helpers";
import { canRefreshGrid, refreshGrid } from "helpers/next-grid-helpers";
import GridAvailabilityToggle from "./grid-availability-toggle";
import RtrPill from "components/design-system/rtr-pill";
import classNames from "classnames";

const baseClass = "grid-top-filters";

const unlimitedMinAvailabilityFilterKey = AvailabilityFilterHelpers.unlimitedMinAvailabilityKey;
const { rtrUpdateMinAvailabilityFilterKey } = AvailabilityFilterHelpers;

const CONSTANTS_MEMBERSHIPLENS = Constants.membershipLens;

const CONSTANTS_MEMBERSHIPLENS_CLASSIC = CONSTANTS_MEMBERSHIPLENS.classic;
const CONSTANTS_MEMBERSHIPLENS_RTRUPDATE = CONSTANTS_MEMBERSHIPLENS.RTRUpdate;
const CONSTANTS_MEMBERSHIPLENS_UNLIMITED = CONSTANTS_MEMBERSHIPLENS.unlimited;

const CONSTANTS_AVAILABILITY = Constants.availabilityFilter;

const AVAILABLE_NOW_AVAILABILITY = 1;
const ALL_STYLES_AVAILABILITY = 0;

const loggingObjectType = Constants.analytics.OBJECT_TYPE.GRID;

class GridTopFiltersComponent extends React.Component {
  static propTypes = {
    attributeFilterCount: PropTypes.number,
    browser: browserPropType.isRequired,
    changeFilters: PropTypes.func.isRequired,
    children: PropTypes.node,
    clearFilters: PropTypes.func.isRequired,
    clearHoldPreferences: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    closeProductDrawer: PropTypes.func.isRequired,
    currentIntent: PropTypes.oneOf(Object.values(Constants.RENTAL_INTENT)),
    dateOptions: PropTypes.shape({
      blackoutDays: PropTypes.arrayOf(PropTypes.string).isRequired,
      dateEnd: PropTypes.string.isRequired,
      dateStart: PropTypes.string.isRequired,
    }).isRequired,
    deliveryCutoffs: PropTypes.array,
    dispatch: PropTypes.func.isRequired,
    displayedModal: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    fetchDeliveryCutoffs: PropTypes.func.isRequired,
    fetchBlackoutDays: PropTypes.func.isRequired,
    fetchMembershipRentalBegin: PropTypes.func.isRequired,
    flagsAndExperiments: flagsAndExperimentsPropType,
    gridMigratedToNext: PropTypes.bool,
    gridType: PropTypes.string,
    gridView: gridViewPropType,
    hideZipFilter: PropTypes.bool,
    isMobileViewport: PropTypes.bool.isRequired,
    isSwapsGrid: PropTypes.bool,
    list: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    loadAddressBook: PropTypes.func.isRequired,
    membershipRentalBeginDate: PropTypes.string,
    membershipState: PropTypes.object,
    message: PropTypes.string,
    messageTwo: PropTypes.string,
    nextGridType: PropTypes.string,
    onChangeSort: PropTypes.func,
    openDateFilterModal: PropTypes.func.isRequired,
    openGridAvailabilityModal: PropTypes.func.isRequired,
    openMobileFilterModal: PropTypes.func.isRequired,
    openShippingFilterModal: PropTypes.func.isRequired,
    openSizeFilterModal: PropTypes.func.isRequired,
    openZipFilterModal: PropTypes.func.isRequired,
    path: PropTypes.string.isRequired,
    resultsCount: PropTypes.number,
    scrollToTopFilters: PropTypes.func,
    setMembershipLens: PropTypes.func.isRequired,
    sort: PropTypes.string.isRequired,
    noPriceSortDropdownMenu: PropTypes.bool,
    submitFilters: PropTypes.func,
    userData: userDataPropType.isRequired,
    workingFilters: PropTypes.shape({
      canonicalSizes: PropTypes.array,
      date: PropTypes.string,
      duration: PropTypes.string,
      zip_code: PropTypes.string,
      availableOnly: PropTypes.bool,
    }).isRequired,
    writeHoldPreferences: PropTypes.func.isRequired,
  };

  static defaultProps = {
    scrollToTopFilters: () => {},
    onChangeSort: () => {},
    userData: {},
    workingFilters: {},
  };

  state = {
    selectedAvailabilityFilter: this.getInitialSelectedMinAvailability(),
  };

  gridTopFilters = React.createRef();

  logDefaultLens() {
    const lens = MembershipHelpers.getUserDataLens(this.props.userData);

    ActionLogger.logAction({
      object_type: loggingObjectType,
      action: "loads",
      default_lens: lens,
    });
  }

  logZipSaved(zipCode) {
    const lens = MembershipHelpers.getUserDataLens(this.props.userData);

    const heapEventData = {
      lens: lens,
      zipCode: zipCode,
      isProspectWithSubscriptionIntent: isProspectWithSubscriptionIntent(
        this.props.membershipState,
        this.props.currentIntent
      ),
    };

    HeapHelpers.fireHeapEvent("zip_code_click_confirm", heapEventData);

    ActionLogger.logAction({
      object_type: loggingObjectType,
      action: "zip_code_click_confirm",
      zip: zipCode,
      lens: lens,
    });
  }

  logSubmitAvailability(selectedFilters) {
    const props = { ...this.props, analyticsObjectType: loggingObjectType, analyticsOpenedFrom: "grid" };
    AvailabilityPreferencesModalHelpers.logFilterAction(props, "explicit", selectedFilters);
  }

  // This will determine what radio button on the non-sub PDP is selected
  setIntent(membershipName) {
    const unlimitedIntent = RentalOptions.NONE;
    const rtrUpdateIntent = RentalOptions.NONE;

    switch (membershipName) {
      case Constants.membershipLens.classic:
        RentalOptionIntent.setLastIntent(RentalOptions.RESERVE, ActionsTaken.RESERVE_SUPERBAR, "grid");
        break;
      case Constants.membershipLens.unlimited:
        RentalOptionIntent.setLastIntent(unlimitedIntent, ActionsTaken.UNLIMITED_PREVIEW_SUPERBAR, "grid");
        break;
      case Constants.membershipLens.RTRUpdate:
        RentalOptionIntent.setLastIntent(rtrUpdateIntent, ActionsTaken.UPDATE_PREVIEW_SUPERBAR, "grid");
        break;
    }
  }

  isSubscriptionMember() {
    const { userData } = this.props;
    return MembershipHelpers.isSubscriptionMember(userData);
  }

  componentDidMount() {
    this.logDefaultLens();
    this.initialiseAddressData();

    const zip = this.props.workingFilters?.zip_code ?? Constants.fallbackZip;

    if (isStorefrontNext()) {
      this.props.fetchDeliveryCutoffs(zip);
      this.props.fetchBlackoutDays(zip);
    }

    if (isStorefrontNext() || this.isShortlistGrid()) {
      this.props.fetchMembershipRentalBegin(zip);
    }
  }

  componentDidUpdate(prevProps) {
    const blackoutDays = this.props?.dateOptions?.blackoutDays;
    const prevBlackoutDays = prevProps?.dateOptions?.blackoutDays;

    if (prevProps.deliveryCutoffs !== this.props.deliveryCutoffs || prevBlackoutDays !== blackoutDays) {
      const chosenDateNotAvailableAnymore = this.chosenDateNotAvailableAnymore();

      // For CX to override delivery cutoffs
      if (isAdmin(this.props.userData)) {
        return;
      } else if (chosenDateNotAvailableAnymore) {
        this.removeDateFilters();
        this.props.openDateFilterModal();
      }
    }
    if (prevProps.userData?.userProfile?.addresses !== this.props.userData?.userProfile?.addresses) {
      this.initialiseAddressData();
    }
  }

  chosenDateNotAvailableAnymore() {
    const selectedDate = this.props?.workingFilters?.date;
    const deliveryCutoffs = this.props?.deliveryCutoffs ?? [];
    const deliveryCutoff = deliveryCutoffs[0];
    const possibleDeliveryDate = deliveryCutoff?.deliveryDate;
    const blackoutDays = this.props?.dateOptions?.blackoutDays;

    if (blackoutDays?.indexOf(selectedDate) >= 0) {
      return true;
    }

    if (!selectedDate || !deliveryCutoffs.length || !possibleDeliveryDate) {
      return false;
    }

    return isBefore(parseISO(selectedDate), parseISO(possibleDeliveryDate));
  }

  getInitialSelectedMinAvailability() {
    const { gridView: { isRtrUpdate, isUnlimited } = {}, userData, workingFilters } = this.props || {};

    if (workingFilters?.date || (!isRtrUpdate && !isUnlimited)) {
      return Constants.availabilityFilter.specificDates;
    } else {
      return AvailabilityFilterHelpers.membershipMinAvailability(userData, workingFilters)
        ? Constants.availabilityFilter.shipsDefault
        : Constants.availabilityFilter.allStyles;
    }
  }

  getAvailabilityLabelIcon() {
    const {
      userData: { isClassicLens },
    } = this.props;

    return isClassicLens ? <CalIcon /> : <RtrParcelIcon className="mb:w-4 mb:h-4 w-5 h-5" />;
  }

  getAvailabilityLabelCopy() {
    const {
      userData: { isClassicLens },
    } = this.props;

    return isClassicLens ? this.getReserveAvailabilityCopy() : this.getSubscriptionAvailabilityCopy();
  }

  getReserveAvailabilityCopy() {
    const {
      workingFilters: { date },
    } = this.props;

    if (!date) {
      return "Choose dates";
    }

    const dateFormat = Constants.dateFnsFormats.M_DD;
    const formattedRentalBeginDate = format(parseISO(date), dateFormat);
    const defaultRentalDuration = 4;
    const duration = this.props.workingFilters?.duration ?? defaultRentalDuration;
    const formattedRentalEndDate = format(addDays(parseISO(date), duration - 1), dateFormat);

    return `Reserve ${formattedRentalBeginDate} - ${formattedRentalEndDate}`;
  }

  getSubscriptionAvailabilityCopy() {
    const { membershipRentalBeginDate, membershipState, workingFilters, userData } = this.props;
    const isFilteredByAvailability = isStorefrontNext()
      ? workingFilters.availableOnly === true
      : AvailabilityFilterHelpers.membershipMinAvailability(userData, workingFilters) > 0;

    if (!isFilteredByAvailability) {
      return "Rent with Membership";
    } else {
      //These should match, but for active subs prefer membershipState as source of truth
      const deliveryDate = MembershipHelpers.getRentBeginDate(membershipState) ?? membershipRentalBeginDate;
      let copy = "Arrives by";
      if (deliveryDate && isToday(parseISO(deliveryDate))) {
        copy = "Arrives";
      }

      return `${copy} ${formattedDeliveryDate(deliveryDate) ?? ""}`;
    }
  }

  getLocationLabel() {
    const { workingFilters, userData, gridView, membershipState } = this.props;

    const workingFiltersZip = workingFilters?.zip_code ?? Constants.fallbackZip;

    if (!isFilteredByShippingAddress(userData, gridView)) {
      const copy = workingFiltersZip;
      return copy;
    }

    // membershipBagAddressZip is not accurate naming for the const value
    // see comment in MembershipHelpers.getShipmentZip
    const membershipBagAddressZip = MembershipHelpers.getShipmentZip(membershipState);
    const copy = membershipBagAddressZip;
    return copy;
  }

  getSizesLabel() {
    const selectedSizes = this.props.workingFilters?.canonicalSizes ?? [];
    return getSizeLabel(selectedSizes, inMaternityExperience(this.props.userData));
  }

  initialiseAddressData = () => {
    // for users that are this.props.RtrUx.isMember(), we already fetch address in on-initialization-actions.js
    if (!isProMember(this.props.userData) && Boolean(getDefaultShippingZip()) && isIdentified(this.props.userData)) {
      this.props.loadAddressBook();
    }
  };

  onClickLocationGridButton = () => {
    const { gridView, openShippingFilterModal, openZipFilterModal, userData } = this.props;
    if (isStorefrontNext()) {
      if (userData?.userProfile?.addresses) {
        isFilteredByShippingAddressNext(userData) ? openShippingFilterModal() : openZipFilterModal();
      } else {
        openZipFilterModal();
      }
    } else {
      isFilteredByShippingAddress(userData, gridView) ? openShippingFilterModal() : openZipFilterModal();
    }
  };

  persistFilters(filters) {
    const newFilters = {
      ...this.props.workingFilters,
      ...filters,
    };
    this.props.writeHoldPreferences(newFilters);
  }

  submitFilters(filters) {
    const newFilters = {
      ...this.props.workingFilters,
      ...filters,
    };
    this.props.changeFilters(newFilters);
    this.props.submitFilters();
  }

  changeMembershipFilters(filters) {
    const availabilityFilters = { ...this.props.workingFilters, ...filters };

    // When viewing membership availability we don't want to include date and duration filters
    const membershipFilters = _.omit(availabilityFilters, ["date", "duration"]);

    this.props.changeFilters(membershipFilters);
  }

  removeDateFilters() {
    const dateFilterKeys = ["date", "duration"];
    this.props.clearHoldPreferences(dateFilterKeys);
    this.props.clearFilters(dateFilterKeys);
  }

  handleZipCodeChange(updatedFilterObject) {
    this.persistFilters(updatedFilterObject);
    this.submitFilters(updatedFilterObject);
  }

  onClickZipSubmit = zipCodeFilter => {
    const zipCode = zipCodeFilter.zip_code;
    if (isStorefrontNext()) {
      this.props.dispatch(productsActions.refreshMembershipDepotIdCookie(zipCode, this.handleZipCodeChange.bind(this)));
    } else {
      this.handleZipCodeChange(zipCodeFilter);
    }

    this.props.closeModal();
    this.props.fetchMembershipRentalBegin(zipCode);
    this.props.fetchDeliveryCutoffs(zipCode);
    this.logZipSaved(zipCode);
  };

  onChangeAddress = address => {
    const { postalCode } = address;
    const zipCodeFilter = { zip_code: postalCode };
    const isSubscriptionMember = MembershipHelpers.isSubscriptionMember(this.props.userData);
    if (isStorefrontNext()) {
      this.props.dispatch(
        productsActions.refreshMembershipDepotIdCookie(postalCode, this.handleZipCodeChange.bind(this))
      );
    } else {
      this.handleZipCodeChange(zipCodeFilter);
    }

    if (!isSubscriptionMember) {
      this.props.fetchMembershipRentalBegin(postalCode);
    }
  };

  onClickSizeSubmit = sizeFilter => {
    const sizes = sizeFilter.canonicalSizes;
    this.persistFilters(sizeFilter);
    this.submitFilters(sizeFilter);
    this.props.closeModal();

    const heapEventData = {
      sizes: sizes.join(","),
      isProspectWithSubscriptionIntent: isProspectWithSubscriptionIntent(
        this.props.membershipState,
        this.props.currentIntent
      ),
    };

    HeapHelpers.fireHeapEvent("size_select", heapEventData);

    ActionLogger.logAction({
      object_type: loggingObjectType,
      action: "size_select",
      itemSizes: sizes.join(","),
    });
  };

  onClickMaternityText = () => {
    if (inMaternityExperience(this.props.userData)) {
      return;
    }

    ActionLogger.logAction({
      object_type: loggingObjectType,
      action: "enter_maternity_flow",
    });
  };

  onClickOptOut() {
    ActionLogger.logAction({
      object_type: loggingObjectType,
      action: "opt_out_maternity_flow",
    });
  }

  onClickSaveDueDate(dueDate) {
    ActionLogger.logAction({
      object_type: loggingObjectType,
      action: "submit_due_date",
      due_date: dueDate,
    });
  }

  onChangeSubscriptionAvailability = (filter, callback = () => {}) => {
    this.setState(
      {
        selectedAvailabilityFilter: filter,
      },
      callback
    );
  };

  currentMembershipAvailabilityView() {
    const { selectedAvailabilityFilter } = this.state;
    return selectedAvailabilityFilter === CONSTANTS_AVAILABILITY.shipsDefault
      ? AVAILABLE_NOW_AVAILABILITY
      : ALL_STYLES_AVAILABILITY;
  }

  onClickAvailabilitySubmit = () => {
    const { isUnlimited, isRtrUpdate } = this.props.gridView || {};
    const { selectedAvailabilityFilter } = this.state;
    const hasRtrUpdateInventory = MembershipHelpers.hasInventoryEligibility(
      this.props.membershipState,
      Constants.inventoryEligibilities.rtr_update
    );

    // The only group with rtr update availability is the 1-swap user.
    // All other fixed swap and non subs will have rtr unlimted availability.
    const minAvailableFilterGroupKey = hasRtrUpdateInventory
      ? rtrUpdateMinAvailabilityFilterKey
      : unlimitedMinAvailabilityFilterKey;

    const selectedMembershipLens = hasRtrUpdateInventory
      ? CONSTANTS_MEMBERSHIPLENS_RTRUPDATE
      : CONSTANTS_MEMBERSHIPLENS_UNLIMITED;

    const membershipAvailabilityFilterData = {
      [minAvailableFilterGroupKey]: this.currentMembershipAvailabilityView(),
    };

    const selectedFilters = { ...this.props.workingFilters, ...membershipAvailabilityFilterData };

    if (selectedAvailabilityFilter === CONSTANTS_AVAILABILITY.specificDates) {
      this.props.openDateFilterModal();
    } else {
      if (_.isEqual(this.props.workingFilters, selectedFilters) && (isUnlimited || isRtrUpdate)) {
        this.props.closeModal();
      } else {
        // RL 5/21 - updated working filters don't need to be submitted using the submitFilters action
        // because the setMembershipLens action does the same thing (redirects to a url with the new filter query params),
        // but including the updated membership lens
        this.persistFilters(membershipAvailabilityFilterData);
        this.changeMembershipFilters(membershipAvailabilityFilterData);
        this.logSubmitAvailability(membershipAvailabilityFilterData);
        this.props.setMembershipLens(selectedMembershipLens);
        this.setIntent(selectedMembershipLens);
        this.props.closeModal();
      }
    }
  };

  onClickDateSubmit = dateFilters => {
    const date = dateFilters?.date ?? "";

    ActionLogger.logAction({
      object_type: loggingObjectType,
      action: "rezo_select",
      rentBegin: date,
      zip: this.props?.workingFilters?.zip_code ?? "",
      itemSizes: (this.props?.workingFilters?.canonicalSizes ?? []).join(","),
    });

    const prevDate = this.props?.workingFilters?.date;
    const prevDuration = this.props?.workingFilters?.duration ?? "4";

    // BARX-953 keep "unavailable in all sizes" items from the grid when date filters are set
    const newDateFilters = Object.fromEntries(
      Object.entries({ ...this.props.workingFilters, ...dateFilters }).filter(
        ([k]) => ![rtrUpdateMinAvailabilityFilterKey, unlimitedMinAvailabilityFilterKey].includes(k)
      )
    );

    this.logSubmitAvailability(newDateFilters);

    // If a member switches views while a product drawer is open it needs to be closed
    this.props.closeProductDrawer();
    this.setIntent(CONSTANTS_MEMBERSHIPLENS_CLASSIC);
    this.props.closeModal();

    //If the top filters are not currently in view, scroll them into view so users see the filter change
    this.props.scrollToTopFilters();

    // FIXME: This is a short-term hack to short-circuit typical behaviour.
    // This _will_ be removed as we iterate on SF.Next grids.
    // With the SF.Next grid rollout we will only support nointent in the upcoming
    // release. In Fastly, if the request has a lens param or the membership_lens
    // cookie set, the request will route to ruby. Otherwise it will route to Next.
    // Here if the user is on a Sf.Next grid and selects:
    // "Choose how you rent -> For special occasions -> Save",
    // we intercept the click and refresh the page with `&lens=classic`. This
    // new document fetch will route to the Ruby layer and the user can continue.
    if (isStorefrontNext()) {
      const currentUrl = window.location.href;

      // PLZ REMOVE THIS WHEN WE ARE ON NEXT FOR RESERVE GRIDS except setting the reserve filters
      /*  
        the function below starts of by 
        - parsing the url into an query object, 
        - mapping new query style objects into ruby style ones
        - Adding classic filters such as date, duration and lens,
        - removing a key so that it doesnt show up as a filter pill for ex - we dont want to show 
          designer name as a pill in designer grids
        - generate the new URL 
      */
      const newStringUrl = compose(
        generateRubyStyleUrl(currentUrl.split("?")[0]),
        removeFilterWhen("designer", () => this.props.nextGridType === Constants.NEXT_GRID_TYPES.designer),
        removeFilterWhen("curation", () => this.props.nextGridType === Constants.NEXT_GRID_TYPES.curation),
        removeFilterWhen("category", () => this.props.nextGridType === Constants.NEXT_GRID_TYPES.category),
        setFilter("filters[date]", newDateFilters.date),
        setFilter("filters[duration]", newDateFilters.duration),
        setFilter("lens", CONSTANTS_MEMBERSHIPLENS.classic),
        mapGridQueryToLegacyFilters(this.props.nextGridType),
        parseQueryString
      )(currentUrl);

      window.location.href = newStringUrl;
      return;
    }

    if (prevDate === dateFilters.date && prevDuration === dateFilters.duration) {
      this.props.setMembershipLens(CONSTANTS_MEMBERSHIPLENS_CLASSIC);
      return;
    }

    if (dateFilters.date === null) {
      this.removeDateFilters();
    } else {
      // RL 5/21 - updated working filters don't need to be submitted using the submitFilters action
      // because the setMembershipLens action does the same thing (redirects to a url with the new filter query params),
      // but including the updated membership lens
      this.persistFilters(dateFilters);
      this.props.changeFilters(newDateFilters);
      this.props.setMembershipLens(CONSTANTS_MEMBERSHIPLENS_CLASSIC);
    }
  };

  onClickBrowseSubscription = () => {
    if (canRefreshGrid(Constants.availabilityFilter.shipsDefault, this.props.gridMigratedToNext)) {
      refreshGrid(Constants.availabilityFilter.shipsDefault, this.props.membershipState);
      return;
    }

    this.onChangeSubscriptionAvailability(Constants.availabilityFilter.shipsDefault, this.onClickAvailabilitySubmit);
  };

  onToggleSubscriptionAvailability = newFilter => {
    const { gridMigratedToNext, membershipState } = this.props;

    if (canRefreshGrid(newFilter, gridMigratedToNext)) {
      refreshGrid(newFilter, membershipState);
      return;
    }

    this.onChangeSubscriptionAvailability(newFilter, this.onClickAvailabilitySubmit);
  };

  buildSortDropdownValues = () => {
    const { membershipState, noPriceSortDropdownMenu } = this.props;
    if (noPriceSortDropdownMenu) {
      return { [Constants.sortKeys.RECOMMENDED]: "Recommended", [Constants.sortKeys.NEWEST]: "Newest" };
    }

    if (isStorefrontNext()) {
      if (MembershipHelpers.isActiveMembership(membershipState)) {
        return { ...Constants.nextGridSortKeysMembership[this.props.nextGridType] };
      }
      return { ...Constants.nextGridSortKeys[this.props.nextGridType] };
    }
    return {
      [Constants.sortKeys.RECOMMENDED]: "Recommended",
      [Constants.sortKeys.NEWEST]: "Newest",
      [Constants.sortKeys.PRICE_DESC]: "High $ - Low $",
      [Constants.sortKeys.PRICE_ASC]: "Low $ - High $",
    };
  };

  renderMobileFilterAndSort() {
    const { attributeFilterCount, openMobileFilterModal, resultsCount } = this.props;

    if (this.isShortlistGrid()) {
      return null;
    }

    //Only show a count if filters have been applied
    const filtersAppliedCount = attributeFilterCount > 0 ? attributeFilterCount : "";
    let sortMarkup;

    if (resultsCount) {
      sortMarkup = (
        <div className={`${baseClass}__sort`}>
          <SortDropdown
            defaultLabel="Sort"
            dispatch={this.props.dispatch}
            dropdownValues={this.buildSortDropdownValues()}
            path={this.props.path}
            onChangeSort={this.props.onChangeSort}
            sort={this.props.sort}
          />
        </div>
      );
    }

    const icon = <FilterIcon />;
    const className = "bg-offWhite";
    const text = `Filters ${filtersAppliedCount}`;

    return (
      <div
        id="attribute-filter-button"
        className="flex justify-end w-100% align-center items-center basis-1/2 md:basis-1/3 gap-2 md:gap-0">
        {sortMarkup}
        <RtrPill
          className={className}
          text={text}
          onClick={openMobileFilterModal}
          icon={icon}
          dataTestId="filter-pill"
        />
      </div>
    );
  }

  isShortlistGrid() {
    const { list } = this.props;
    return typeof list !== "undefined";
  }

  isKidsGrid() {
    const { gridView } = this.props;
    return isGridType(gridView, "Kids");
  }

  getSizeHedText() {
    const { userData } = this.props;
    const titleText = {
      ...Constants.sizeFilterLabels,
      default: "What are your go-to sizes?",
    };

    if (this.isKidsGrid()) {
      return "What are your kid&#39;s go-to sizes?";
    } else if (inMaternityExperience(userData)) {
      return titleText.inMaternity;
    }

    return titleText.default;
  }

  getSizeDekText() {
    const dekText = "Select a few that fit you the best.";

    if (this.isKidsGrid()) {
      return "Sizes run in years. Select a few that fit them best.";
    }

    return dekText;
  }

  renderLocationFilter() {
    const { browser, displayedModal, gridView = {}, workingFilters, hideZipFilter } = this.props;

    if (hideZipFilter || !gridView.isRentable) {
      return null;
    }

    const icon = <PinIcon />;
    const baseClass = "bg-offWhite";

    return [
      <RtrPill
        key="locationPill"
        icon={icon}
        onClick={this.onClickLocationGridButton}
        text={this.getLocationLabel()}
        className={baseClass}
        dataTestId="zip-pill"
      />,
      <GridTopFiltersZipModal
        browser={browser}
        displayedModal={displayedModal}
        onRequestClose={this.props.closeModal}
        onSubmit={this.onClickZipSubmit}
        workingFilters={workingFilters}
        key="gridTopFiltersZipModal"
      />,
      <GridTopFiltersAddressModal onChange={this.onChangeAddress} key="gridTopFiltersAddressModal" />,
    ];
  }

  renderSizeFilter() {
    const { browser, displayedModal, gridType, openSizeFilterModal, userData, workingFilters } = this.props;

    if (gridType === Constants.gridTypes.saleables) {
      return null;
    }

    const sizesText = this.getSizesLabel();
    const baseClass = "bg-offWhite";

    return (
      <>
        <RtrPill
          onClick={openSizeFilterModal}
          text={sizesText}
          key="sizeFilterButton"
          className={baseClass}
          dataTestId="size-pill"
        />
        <GridTopFiltersSizeModal
          browser={browser}
          defaultSizeHedText={this.getSizeHedText()}
          defaultSizeDekText={this.getSizeDekText()}
          displayedModal={displayedModal}
          onClickCancel={() => {}}
          onClickMaternityText={this.onClickMaternityText}
          onClickOptOut={this.onClickOptOut}
          onClickSave={this.onClickSaveDueDate}
          onRequestClose={this.props.closeModal}
          onSubmit={this.onClickSizeSubmit}
          userData={userData}
          workingFilters={workingFilters}
          key="gridTopFiltersSizeModal"
        />
      </>
    );
  }

  renderAvailabilityFilter() {
    const {
      browser,
      currentIntent,
      dateOptions,
      deliveryCutoffs,
      displayedModal,
      gridView,
      openDateFilterModal,
      openGridAvailabilityModal,
      workingFilters,
      flagsAndExperiments,
      membershipState,
    } = this.props;

    if (!gridView?.isRentable) {
      return;
    }

    //Users who have already indicated Reserve intent should just be shown a date picker modal
    const onClickFilterButton =
      currentIntent === Constants.RENTAL_INTENT.RESERVE ? openDateFilterModal : openGridAvailabilityModal;

    const hedText = "When do you need it?";

    const hideBrowseAllCta =
      flagsAndExperiments?.[flagsAndExperimentNames.HIDE_BROWSE_ALL_FROM_T0_SUBS] &&
      membershipState?.membershipTermNumber === 0;

    const availabilityLabelContent = (
      <>
        {this.getAvailabilityLabelCopy()}
        <span className="reb-DownArrow"></span>
      </>
    );

    const baseClass = "bg-offWhite";

    return (
      <>
        <RtrPill
          onClick={onClickFilterButton}
          text={availabilityLabelContent}
          key="availabilityFilterButton"
          className={baseClass}
          icon={this.getAvailabilityLabelIcon()}
          dataTestId="availability-pill"
        />
        <GridAvailabilityModal
          key="gridAvailabilityModal"
          isSubscriber={MembershipHelpers.isActiveMembership(membershipState)}
          onChange={this.onChangeSubscriptionAvailability}
          onClickBrowse={this.onClickAvailabilitySubmit}
          onRequestClose={this.props.closeModal}
          hideBrowseAllCta={hideBrowseAllCta}
        />
        <GridTopFiltersDateModal
          browser={browser}
          dateOptions={dateOptions}
          deliveryCutoffs={deliveryCutoffs}
          displayedModal={displayedModal}
          hedText={hedText}
          key="gridTopFiltersDateModal"
          onChange={() => {}}
          onClickBrowse={this.onClickDateSubmit}
          onClickBrowseSubscription={this.onClickBrowseSubscription}
          onRequestClose={this.props.closeModal}
          workingFilters={workingFilters}
          message={this.props.message}
          messageTwo={this.props.messageTwo}
          onClickBack={openGridAvailabilityModal}
        />
      </>
    );
  }

  renderSuperBar() {
    const sizeFilter = this.renderSizeFilter();
    const availabilityFilter = this.renderAvailabilityFilter();
    const locationFilter = this.renderLocationFilter();

    return (
      <GridSuperBar sizeFilter={sizeFilter} availabilityFilter={availabilityFilter} locationFilter={locationFilter} />
    );
  }

  render() {
    const { children, gridView, isMobileViewport, resultsCount, isSwapsGrid } = this.props;
    const hideAvailabilityToggle = isSwapsGrid || !gridView?.isRentable;
    //Superbar renders in the same line as other filters on desktop, or when there is no availability toggle
    const renderSuperbarInline = !isMobileViewport || hideAvailabilityToggle;

    const gridTopFiltersClasses = classNames(
      "flex",
      "justify-between",
      "w-full",
      "flex-col",
      "md:flex-row",
      "relative",
      "pl-4",
      "pr-3",
      "md:px-16",
      {
        "mt-6 md:mt-14": !resultsCount,
      }
    );

    return (
      <div className="pb-3" key="grid-top-filters">
        <div className={gridTopFiltersClasses} ref={this.gridTopFilters}>
          {!renderSuperbarInline && this.renderSuperBar()}
          <div className="w-full flex items-center justify-between">
            {!hideAvailabilityToggle && (
              <GridAvailabilityToggle
                isShortlistGrid={this.isShortlistGrid()}
                updateAvailabilityFilters={this.onToggleSubscriptionAvailability}
              />
            )}
            {renderSuperbarInline && this.renderSuperBar()}
            {this.renderMobileFilterAndSort()}
          </div>
        </div>
        <div>{children}</div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    displayedModal: state.displayedModal,
    isMobileViewport: state.browser.isMobileViewport,
    nextGridType: state.nextGridType,
    workingFilters: state.workingFilters,
    gridMigratedToNext: state.migratedToNext,
    membershipRentalBeginDate: state.membershipRentalBeginDate,
  };
};

export const mapDispatchToProps = {
  changeFilters: productsActions.changeFilters,
  clearFilters: productsActions.clearFilters,
  clearHoldPreferences: holdPreferencesActions.clearHoldPreferences,
  closeModal,
  closeProductDrawer: productDrawerActions.closeProductDrawer,
  fetchBlackoutDays: deliveryCutoffActions.fetchBlackoutDays,
  fetchDeliveryCutoffs: deliveryCutoffActions.fetchDeliveryCutoffs,
  fetchMembershipRentalBegin: MembershipRentalBeginActions.fetchMembershipRentalBegin,
  loadAddressBook,
  openDateFilterModal,
  openGridAvailabilityModal,
  openMobileFilterModal,
  openShippingFilterModal,
  openSizeFilterModal,
  openZipFilterModal,
  setMembershipLens: productsActions.setMembershipLens,
  writeHoldPreferences: holdPreferencesActions.writeHoldPreferences,
};

export { GridTopFiltersComponent as UnconnectedGridTopFilters };

export default compose(
  withUserData,
  connect(mapStateToProps, mapDispatchToProps),
  withCookies,
  withOnLoadFlagsAndExperiments(flagsAndExperimentNames.HIDE_BROWSE_ALL_FROM_T0_SUBS)
)(GridTopFiltersComponent);
